import { useEffect, useState } from "react";
import { io } from "socket.io-client";

let socketInstance = null; // Singleton instance

const useSocket = (url, event, callback, subscriptionData) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Check if socketInstance is already created, if not, create a new one
    if (!socketInstance) {
      socketInstance = io(url);
    }
    setSocket(socketInstance);

    // Emit subscription event if provided
    if (subscriptionData) {
      socketInstance.emit(subscriptionData.event, subscriptionData.data);
    }

    return () => {
      // Emit unsubscription event if provided
      if (subscriptionData) {
        socketInstance.emit(
          subscriptionData.unsubscribeEvent,
          subscriptionData.data
        );
      }
      // Do not close the socketInstance to maintain the singleton pattern
    };
  }, [
    url,
    subscriptionData?.event,
    subscriptionData?.data,
    subscriptionData?.unsubscribeEvent,
  ]);

  useEffect(() => {
    if (socket) {
      socket.on(event, callback);
    }
    return () => {
      if (socket) {
        socket.off(event, callback);
      }
    };
  }, [socket, event, callback]);

  return socket;
};

export default useSocket;
